module.exports = __webpack_public_path__ + "static/media/ResponPic5.30af6e59.jpg";